module.exports = __webpack_public_path__ + "static/media/laptopConfig.aaa022ce.svg";